//
//
//
//
//
//
//
//

import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'

export default {
  name: "home",
  data() {
    return {
      value: ""
    };
  },
  components: { },
  computed: {

  },
  methods: {
    to(){
      window.open("https://support.microsoft.com/zh-cn/topic/internet-explorer-%E4%B8%8B%E8%BD%BD-d49e1f0d-571c-9a7b-d97e-be248806ca70", '_blank')
    },
    
  }

};



// WEBPACK FOOTER //
// ./src/pages/not/404.vue